import React, { useState } from "react";
import DefaultProfilePick from "../../../../assets/image/default_user_avatar.png";
import { css } from "styled-components/macro";
import { FileValidation } from "../../../../utils/general";
import { toast } from "react-toastify";
function ProfilePic({ set }) {
  const [pic, setPic] = useState(DefaultProfilePick);
  const handleFile = e => {
    let file = e.target.files[0];
    if (e.target.files[0]) {
      try {
        FileValidation(file, { size: 200, type: "image", typeTitle: "تصویر" });
        set("avatar", e.target.files[0]);
        let reader = new FileReader();
        reader.onload = e => {
          setPic(e.target.result);
        };

        reader.readAsDataURL(e.target.files[0]);
      } catch (error) {
        toast.warn(error.message);
      }
    }
  };
  return (
    <div style={{ position: "relative" }}>
      <div
        css={css`
          display: inline-block;
          position: relative;
          width: 170px;
          height: 170px;
          overflow: hidden;
          border-radius: 50%;
          border: 2px solid var(--color1);
        `}
      >
        <img
          css={css`
            width: 100%;
            height: 100%;
          `}
          src={pic}
        ></img>
        <input
          onChange={handleFile}
          style={{ display: "none" }}
          type="file"
          id="signUp-Pic"
        ></input>
      </div>
      <label
        htmlFor="signUp-Pic"
        css={css`
          position: absolute;
          width: 30px;
          height: 30px;
          bottom: 15px;
          border-radius: 50%;
          border: unset;
          padding: 0;
          right: calc(50% - 70px);
          background: var(--success);
          box-shadow: 1px 1px 4px #000;
        `}
      >
        <i
          css={css`
            display: block !important;
            text-align: center !important;
            font-size: 2rem !important;
            color: #fff !important;
            line-height: 30px !important;
          `}
          className="md md-plus"
        ></i>
      </label>
    </div>
  );
}
export default ProfilePic;
